import React, { useRef } from 'react';
import { Breed } from '../../../../../structures/models/breed';
import useElementSize from '../../../../../utils/hooks/useElementSize';
import ConsistentSpaceImage from '../../../../icon/consistent-space-image';
import BreedSubHeader from './BreedSubHeader';

interface BreedHeaderProps {
  breed: Breed,
  width: number,
  breakpoint: number,
  listingTypePlural: string,
  isLearnMoreOpen: boolean,
  setIsLearnMoreOpen: React.Dispatch<React.SetStateAction<boolean>>,
  scrollToSearch: () => void,
}

const BreedHeader: React.FC<BreedHeaderProps> = ({
  breed,
  width,
  breakpoint,
  listingTypePlural,
  isLearnMoreOpen,
  setIsLearnMoreOpen,
  scrollToSearch,
}) => {
  const findBtnRef = useRef(null);
  const { width: findBtnWidth } = useElementSize(findBtnRef);

  const containerRef = useRef(null);
  const { width: containerWidth } = useElementSize(containerRef, false);

  // If on mobile and the buttons are wide enough to stack, limit the width of the learn more
  // button to that of the find button. This helps the learn more button to appear more centered
  // at certain screen widths / certain breed names
  const shouldLimitWidth = width < breakpoint && (findBtnWidth * 2 > containerWidth);

  return (
    <div className="breed-header">
      <section className="puppy-breed-section">
        <div className="container-fluid">
          <div className="row">
            <div className="breed-image-container">
              <ConsistentSpaceImage
                src={breed.thumbnailUrl}
                alt={`${breed.name}.`}
                verticalAlign={width < breakpoint ? 'top' : 'middle'}
              />
            </div>
            <div className="puppy-right-content">
              <div className="puppy-right-content-inner">
                {width >= breakpoint && (
                  <BreedSubHeader breed={breed} />
                )}
                <div className="buttons-container" ref={containerRef}>
                  <button
                    className="btn btn-lg find-btn"
                    type="button"
                    onClick={() => scrollToSearch()}
                    ref={findBtnRef}
                  >
                    <img src="/assets/puppy-icon.svg" alt="" className="mr-2" />
                    <strong>
                      See Available
                      {' '}
                      {listingTypePlural}
                    </strong>
                  </button>
                  <button
                    className="learn-btn btn btn-link border-none"
                    type="button"
                    onClick={() => setIsLearnMoreOpen((i) => !i)}
                    style={shouldLimitWidth ? { maxWidth: findBtnWidth } : {}}
                  >
                    <span>
                      <i className={`fa fa-angle-down toggle-indicator ${isLearnMoreOpen ? 'toggled' : ''}`} />
                    </span>
                    Learn more about
                    {' '}
                    {breed.pluralName}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BreedHeader;
